import { Alert, Spinner } from '@acpaas-ui/react-components';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDone, fetchError as fetchErrorAction, fetchReset, fetchStart } from '../../actions/fetch.actions';
import { resourceAdd, resourceReset } from '../../actions/resources.actions';
import { usePrevious } from '../../hooks/usePrevious';
import {
  fetchedSelector,
  fetchErrorSelector,
  fetchingSelector,
  shouldFetchSelector
} from '../../selectors/fetch.selectors';
import { resourceStateSelector } from '../../selectors/resources.selectors';
import { forms } from '../../services/bff.api';
import FormsViewFallback from './FormsViewFallback';

const Widget = window.auiEmbeddableWidgets.reactComponent(
  'https://formwidget.antwerpen.be/definitions/v1/form-viewer.json',
  {
    React,
    ReactDOM
  }
);

const FormViewWidget = ({ className = '', formData, formSnapshot, resource, slug }) => {
  const dispatch = useDispatch();
  const prevSlug = usePrevious(slug);
  const fetchError = useSelector((state) => fetchErrorSelector(state, { resource }));
  const fetching = useSelector((state) => fetchingSelector(state, { resource }));
  const fetched = useSelector((state) => fetchedSelector(state, { resource }));
  const shouldFetch = useSelector((state) => shouldFetchSelector(state, { resource }));
  const formState = useSelector((state) => resourceStateSelector(state, { resource }));

  useEffect(() => {
    if (!slug || !shouldFetch) {
      return;
    }

    dispatch(fetchStart({ key: resource.key }));
    forms
      .getBySlug(slug)
      .then((data) => {
        if (data.status !== 200) {
          throw new Error(data.json?.message ?? 'Kan formulier niet laden.');
        }
        const jsonData = data.json;
        dispatch(resourceAdd({ key: resource.key }, { jsonData: jsonData || {} }));
        dispatch(fetchDone({ key: resource.key }));
      })
      .catch((err) => {
        dispatch(fetchErrorAction({ key: resource.key }, err.message));
      });
  }, [dispatch, resource?.key, slug, shouldFetch]);

  useEffect(() => {
    if (!prevSlug) {
      return;
    }
    if (prevSlug !== slug) {
      dispatch(resourceReset({ key: resource.key }));
      dispatch(fetchReset({ key: resource.key }));
    }
  }, [dispatch, resource?.key, slug, prevSlug]);

  if (fetchError) {
    return (
      <>
        <Alert type="danger" className="u-margin-bottom">
          Kan het formulier niet laden.{!!formSnapshot && ' Vind een momentopname van de antwoorden hieronder.'}
        </Alert>
        {!!formSnapshot && <FormsViewFallback content={formSnapshot} />}
      </>
    );
  }

  if (fetching || !fetched) {
    return (
      <div className="u-text-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className={`spo-o-forms ${className}`}>
      <Widget schema={formState?.jsonData?.template?.content || {}} form={formData || {}} />
    </div>
  );
};

export default FormViewWidget;
